import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getCompaniesByApplicationId(applicationId: string) {
  return await prisma.applicantCompany.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
